import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from 'react-router-dom';

export interface INotFoundProps {
  [name: string]: any;
}

/**
 * 404 Not Found Page - Clean & Open Layout without Paper
 */
export const NotFound: React.FC<INotFoundProps> = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor={theme.palette.background.default}
      px={3}
      textAlign="center"
    >
      <ErrorOutlineIcon
        sx={{
          fontSize: 100,
          color: theme.palette.error.main,
          mb: 2,
          transition: 'transform 0.3s ease',
          '&:hover': { transform: 'rotate(-6deg) scale(1.15)' },
          userSelect: 'none',
        }}
      />
      <Typography variant="h1" fontWeight="bold" color="error" gutterBottom>
        404
      </Typography>
      <Typography variant="h5" color="text.secondary" fontWeight={500} gutterBottom>
        Oops! Page Not Found
      </Typography>
      <Typography variant="body1" color="text.secondary" maxWidth={480} mb={4}>
        The page you are looking for might have been removed, <br />
        had its name changed, or is temporarily unavailable.
      </Typography>


    </Box>
  );
};

export default NotFound;
